import styleInject from './node_modules/style-inject/dist/style-inject.es.js';
var css_248z = "/* add css styles here (optional) */\n.view-container {\n    position: relative;\n    overflow: hidden;\n}";
styleInject(css_248z);
export { css_248z as default };
//# sourceMappingURL=styles.css.js.map
